<template>
  <button :key="status.id" class="position-relative px-3 py-1" :class="statusClass" style="border-radius: 15px">
    <div class="shadow position-absolute p-1" :style="`background-color:${status.color}; opacity:0.1;`"></div>
    <div :style="`color:${status.color}`" class="statusTextDiv">
      <span v-if="title"> اتمام کار: </span>
      <span class="statusText">{{ status.value }}</span>
    </div>
  </button>
</template>

<script>
export default {
  name: 'status',
  props: {
    status: {
      type: Object,
    },
    color: {
      type: String,
    },
    statusClass: {
      type: String,
      default: '',
    },
    title: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
button {
  min-width: 103px !important;
  text-align: center;
  background-color: transparent !important;
  cursor: default;
}
.shadow {
  border-radius: inherit;
  overflow: hidden;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  max-height: 22px;
}
.statusText { 
  font-size: 12px;
  margin: -4px 0 0 0;
}
.statusTextDiv {
  margin: -4px 0 0 0;
}
</style>